var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.0727,
    y: 1.0185,
    width: 36.8548,
    height: 36.8866,
    rx: 4.5274,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.0727,
    y: 1.0185,
    width: 36.8548,
    height: 36.8866,
    rx: 4.5274,
    stroke: "#DEDFEC",
    strokeWidth: 0.945207
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2916 13.9583C22.9673 14.0902 23.6381 14.3882 24.1249 14.875C24.6118 15.3618 24.9098 16.0326 25.0416 16.7083M22.7499 10.75C24.1538 10.906 25.4172 11.5851 26.4166 12.5833C27.4161 13.5815 28.0922 14.8463 28.2499 16.25M28.2494 23.1036V25.5876C28.2533 26.5371 27.3995 27.33 26.4409 27.2435C18.1667 27.25 11.75 20.7737 11.7565 12.5551C11.6701 11.6015 12.4591 10.751 13.4074 10.7501H15.8963C16.2989 10.7461 16.6893 10.8884 16.9945 11.1504C17.8625 11.8954 18.4207 14.4238 18.2059 15.4289C18.0382 16.2137 17.2472 16.7627 16.7093 17.2994C17.8904 19.3723 19.6101 21.0887 21.6871 22.2673C22.2249 21.7306 22.775 20.9411 23.5613 20.7737C24.57 20.559 27.1147 21.1181 27.8566 21.992C28.1197 22.3019 28.2595 22.6975 28.2494 23.1036Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.84dc2fb9b08dbba97bd6b9b9296b8616.svg";
export { ForwardRef as ReactComponent };